<template>
  <div class="club_page">
    <ClubHeader>
      <template v-slot:club-header-title>
        <h2 class="mar10t">باشگاه مشتریان</h2>
      </template>
    </ClubHeader>
    <div class="club-box">
      <ClubContainer class="mar5t mar10b" style="background: #fff;">
        <template v-slot:ticket-right>
          <div class="dFlex">
            <p class="mar5t">{{ bonusList.score | persian }}</p>
            <i class="fas fa-shopping-cart mar10r primary-color"></i>
          </div>
          <p style="font-size: 10px;">امتیاز مورد نیاز</p>
        </template>
        <template v-slot:ticket-left>
          <div class="dFlex bonus-content">
            <h3 class="primary-color font-bold">
              {{ bonusList.title | persian }}
            </h3>
          </div>
        </template>
      </ClubContainer>
      <ClubFooter></ClubFooter>
      <div>
        <div>
          <img :src="bonusList.imageUrl" class="w-100 box-shadow" v-if="bonusList.imageUrl" />
          <img src="../../assets/img/logo-bg1.png" v-else class="w-100 b-radiuse5" />
        </div>
        <p class="secondary-text-color textJustify mar20t" style="white-space: pre-line;">
          {{ bonusList.description }}
        </p>
        <div @click="urlClicked" class="input primary-btn w-100 mar20t">
          ورود به سایت
        </div>

        <div class="dFlex justify-space-between align-items-center mar20t">
          <p class="red-text mb-0">
            مهلت استفاده: تا <span> {{ bonusList.dateEnd }} </span>
          </p>
          <p class="mb-0 primary-color">
            امتیاز مورد نیاز:
            <span> {{ bonusList.score | persian }} </span> امتیاز
          </p>
        </div>

        <div v-if="
          bonusTotal == bonusUsed ||
          bonusTotal <= 0 ||
          bonusList.dateEnd < todayDate
        " class="error-message textCenter">
          مهلت خرید این محصول تمام شده است
        </div>

        <div class="input dFlex primary-btn mar20t mar20b" id="buy" v-else>
          <i class="fas fa-shopping-cart mar10r"></i>
          <div @click="buyBonus()">خرید محصول با امتیاز باشگاه مشتریان</div>
        </div>
      </div>
      <div class="error-message textCenter" v-if="errorMessage">
        {{ errorMessage }}
      </div>
      <loader v-if="loading" />
      <div v-if="successMessage" class="copy-box textCenter" id="buy-bonus-alert">
        <i class="fa fa-times cursor-pointer" @click="close()"></i>
        <div class="success-message mar20t">{{ successMessage }}</div>
        <p>
          برای مشاهده این کد تخفیف یا جایزه به قسمت جایزه‌های دریافتی بروید.
        </p>
        <div class="dFlex mar10t justify-space-between">
          <p>کد تخفیف شما:</p>
          <div id="textToCopy" class="primary-color cursor-pointer w-75 border b-radiuse5 pad5" @click="copyAlert()"
            v-clipboard="bonusDetail.code">
            {{ bonusDetail.code }}
          </div>
        </div>
      </div>
      <div class="copy-box" v-if="copyText">کد با موفقیت کپی شد!</div>
    </div>
  </div>
</template>

<script>
import api from "../../service";
import ClubHeader from "../../components/Club/Header.vue";
import ClubContainer from "../../components/Club/ScoreContainer.vue";
import ClubFooter from "../../components/Club/ClubFooter.vue";
import { mapActions, mapGetters } from "vuex";
import loader from "../../components/inquiry/Loader";

export default {
  components: {
    ClubHeader,
    ClubContainer,
    ClubFooter,
    loader,
  },
  props: {
    bonusId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      bonusList: [],
      bonusTotal: "",
      bonusUsed: "",
      hasToken: false,
      userId: "",
      bonusDetail: {},
      errorMessage: false,
      successMessage: false,
      copyText: false,
      loading: true,
    };
  },
  created() {
    this.canCopy = !!navigator.clipboard;
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  mounted: function () {
    // console.log(this.$route.query.token);
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token);
    }
    // if (this.$route.query.token) {
    //   api.getUserInformation().then((response) => {
    //     if (response.data && response.data.status === 200) {
    //       this.userId = response.data.data.userId;
    //       // console.log(this.userId);
    //     } else {
    //       if (
    //         response.data &&
    //         response.data.messages &&
    //         response.data.messages.length > 0
    //       ) {
    //         this.errorMessage = response.data.messages[0];
    //       }
    //     }
    //   });
    // }
    if (this.$route.query.token) {
      this.bonusId = this.$route.params.bonusId;
      api
        .getBonus(this.bonusId)
        .then((response) => {
          // console.log(response);
          if (response.data && response.status === 200) {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            var bonusArray = response.data.data.bonus;
            var score = bonusArray.score;
            bonusArray.score = score.toString().replace(/-/g, "");
            var dateEnd = bonusArray.dateEnd;
            //console.log(dateEnd);
            bonusArray.dateEnd = new Date(dateEnd).toLocaleDateString("fa-IR");
            this.bonusList = bonusArray;
            this.bonusTotal = response.data.data.total;
            this.bonusUsed = response.data.data.used;
            this.$ga.event("ticket", "ticketTitle", this.bonusList.title);
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch(() => {
          this.errorMessage = "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        });
    }
  },
  methods: {
    ...mapActions(["setTheme", "setToken"]),
    urlClicked() {
      this.$ga.event("ticket", "ticketURL", this.bonusList.title);
      window.location.href = this.bonusList.linkAddres;
    },
    buyBonus() {
      api
        .usedBonusCode(this.bonusId)
        .then((response) => {
          // console.log(response);
          if (response.data && response.data.status === 200) {
            this.bonusDetail = response.data.data;
            //console.log(this.bonusDetail);
            this.$ga.event("ticket", "ticketBuy", this.bonusList.title);

            this.successMessage = response.data.messages[0];
          } else {
            console.log(response.data);
            if (
              response.data &&
              response.data.status === 500 &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            } else if (
              response.data &&
              response.data.status === 200 &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              console.log('asghar');
              this.successMessage = response.data.messages[0];
            }
          }
        })
        .catch(() => {
          this.errorMessage = "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copyAlert() {
      this.copyText = true;
      setTimeout(() => (this.copyText = false), 3000);
    },
    close() {
      const remove = document.getElementById("buy-bonus-alert");
      remove.remove();
    },
  },
};
</script>
<style scoped>
.right-side>div {
  font-size: 22px;
}

.custom-box {
  background: #fff;
  border-bottom: 10px solid #002664;
  margin: -50px 0px 20px;
}

.custom-box img {
  width: 50px;
}

.club-box {
  padding: 0 30px;
  margin: -50px auto 20px;
}

a {
  color: #000;
}

#buy-bonus-alert {
  bottom: 0;
  background: #fff;
  color: #666;
  box-shadow: 0 0 5px 2px #e3e3e3;
  width: 100%;
  padding: 10px;
  position: fixed;
  z-index: 1000;
  left: 50%;
  transform: translate(-50%);
  max-width: 760px;
}

#buy-bonus-alert i {
  position: absolute;
  left: 10px;
}

.gray-box {
  width: auto;
}

.loader {
  background: #fff !important;
}
</style>
